import nxModule from 'nxModule';
import LocalCache from 'shared/utils/localCache';

nxModule.factory('accountProductsCache', (http, CacheFactory, config) =>
  new LocalCache({
    provider: () => http.get('/products/accounts/types'),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.accountProducts,
    cacheName: 'accountTypes'
  }));